import { render, staticRenderFns } from "./infoIndex.vue?vue&type=template&id=0c9e8402&scoped=true&"
import script from "./infoIndex.vue?vue&type=script&lang=js&"
export * from "./infoIndex.vue?vue&type=script&lang=js&"
import style0 from "./infoIndex.vue?vue&type=style&index=0&id=0c9e8402&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9e8402",
  null
  
)

export default component.exports